import actionTypes from '../constants/action-types';

const changeFontPairs = () => ({
  type: actionTypes.CHANGE_FONT_PAIRS,
});

export default changeFontPairs;
